import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private apiService: ApiService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.apiService.token.pipe(
      take(1),
      map(token => !!token),
      tap(loggedIn => {
        if (!loggedIn) {
          this.router.navigateByUrl('/auth/login');
        }
      })
    );
  }
}
